<i18n>
{
    "en": {
    },
    "ru": {
        "title": "Добавить на полку",
        "add": "Добавить",
        "empty_shelves": "Полок нет",
        "save": "Сохранить"
    }
}
</i18n>

<template>

    <modal-content
        class="perfume-shelves-modal"
        :class="rootClasses"
        :footer-shadow="shelves && shelves.length > 7"
        no-padding-footer
        no-padding-body>

        <template #title>
            {{ $t('title') }}
        </template>

        <template #body>
            <div class="perfume-shelves"
                v-if="shelves.length">
                <div class="perfume-shelves__container">
                    <PopupCheckbox
                        v-for="shelf in shelves"
                        bordered
                        nowrap
                        :key="shelf.id"
                        :value="shelf.id"
                        v-model="checkedShelves">
                        {{ shelf.name }}
                    </PopupCheckbox>
                </div>
            </div>
            <p class="perfume-shelves__empty"
                v-else>
                {{ $t('empty_shelves') }}
            </p>
        </template>
        <footer
            slot="footer"
            class="perfume-shelves__footer">
            <ButtonBase
                class="perfume-shelves__button"
                :disabled="isButtonDisabled"
                @click.native="save">{{ buttonText }}</ButtonBase>
        </footer>
    </modal-content>

</template>

<script>
import xor from 'lodash/xor'
import ModalContent from '@/components/modal/ModalContent'
import PopupCheckbox from '@/components/ui/PopupCheckbox'
import ButtonBase from '@/components/ui/buttons/ButtonBase'

export default {
    name: 'PerfumeShelves',
    components: {
        ModalContent,
        PopupCheckbox,
        ButtonBase
    },
    props: {
        shelves: {
            type: Array,
            default: () => []
        },
        onShelf: {
            type: Array,
            default: () => {}
        },
        isTooltip: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            checkedShelves: []
        }
    },
    computed: {
        rootClasses() {
            return {
                'perfume-shelves-modal_tooltip': this.isTooltip
            }
        },
        isButtonDisabled() {
            return !this.shelves.length ||
                !xor(this.checkedShelves, this.onShelf).length
        },
        buttonText(){
            return this.onShelf.length > 0 ? this.$t('save') : this.$t('add');
        }
    },
    created() {
        this.checkedShelves = this.onShelf
    },
    methods: {
        hide() {
            this.$modal.hide()
        },
        save() {
            this.$bus.$emit('shelves-selected', this.checkedShelves)
            this.hide()
        }
    }
}
</script>

<style lang="less">
.perfume-shelves {

    &-modal {
        padding-right: 0;
        padding-left: 0;

        max-height: 85vh;
        max-width: none;

        &_tooltip {
            background-color: @color-white;
            border-radius: rem(3);
            box-shadow: 0 rem(3) rem(16) rgba(0, 0, 0, 0.08);

            height: auto;
            max-height: 75vh;

            position: relative;
            z-index: 100;

            overflow: hidden;

            transition: transform 0.3s ease-in-out;

            transform-origin: top;

            @{desktop} & {
                width: rem(290);

                top: rem(7);
            }
        }
    }


    &__footer {
        padding: @dim-page-padding;
    }

    &__button {
        width: 100%;
    }

    &__empty {
        padding: 0 @dim-page-padding;
    }
}
</style>
